import React, { Component } from 'react'
import { Gmaps, Marker, InfoWindow, Circle } from 'react-gmaps'

const params = { v: '3.exp', key: 'AIzaSyDploFGP3AEHNl2kYRd7UjG07NhPQ8xxRc' }

class Map extends Component {
	constructor(props) {
		super(props)
	}
	onMapCreated(map) {
		map.setOptions({
			disableDefaultUI: true,
		})
	}
	onDragEnd(e) {
		console.log('onDragEnd', e)
	}
	onCloseClick() {
		console.log('onCloseClick')
	}
	onClick(e) {
		console.log('onClick', e)
	}
	render() {
		return (
			<Gmaps
				width={'100%'}
				height={'400px'}
				lat={this.props.lat}
				lng={this.props.lng}
				zoom={12}
				loadingMessage={'loading map...'}
				params={params}
				onMapCreated={this.onMapCreated}
			>
				<Marker
					lat={this.props.lat}
					lng={this.props.lng}
					draggable={true}
				/>
				<Circle
					lat={this.props.lat}
					lng={this.props.lng}
					radius={500}
				/>
			</Gmaps>
		)
	}
}

export default Map



// WEBPACK FOOTER //
// ./src/components/Gmaps.js